<button *ngIf="!isNode" class="new_button" (click)="downloadVoucher()">
                {{'CONFIRMATION_DOWN' | translate}}
                <i class="material-icons">get_app</i> 
              </button>